import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Button from '../components/Button';

const Payment = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { formData } = location.state || { formData: { name: 'Student', course: 'Silambam - Beginner' } };
    const [paymentMethod, setPaymentMethod] = useState('upi');
    const [isProcessing, setIsProcessing] = useState(false);

    const handlePayment = async () => {
        setIsProcessing(true);
        try {
            // Ensure registration is saved (in case it wasn't saved earlier)
            if (formData && formData.name && formData.email) {
                try {
                    const regRes = await fetch('/api/register', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(formData)
                    });
                    const regJson = await regRes.json();
                    if (!regRes.ok) {
                        console.warn('Registration before payment failed:', regJson);
                    } else {
                        console.log('Registration saved before payment:', regJson);
                    }
                } catch (regErr) {
                    console.warn('Could not save registration before payment:', regErr);
                }
            }

            // Send CSV via email
            const emailResponse = await fetch('/api/send-csv', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    recipientEmail: 'logesh.b2213@gmail.com'
                })
            });

            if (!emailResponse.ok) {
                const err = await emailResponse.json().catch(() => ({ error: 'Unknown error' }));
                throw new Error(err.error || 'Failed to send email');
            }

            const emailResult = await emailResponse.json();
            console.log('Email sent:', emailResult);

            alert('Payment processed successfully! Registration data has been sent to logesh.b2213@gmail.com. Welcome to the academy.');
            navigate('/');
        } catch (error) {
            console.error('Payment error:', error);
            alert('Payment processed but failed to send email. Please contact support.');
            navigate('/');
        } finally {
            setIsProcessing(false);
        }
    };

    return (
        <>
            <section className="hero" style={{ minHeight: '40vh' }}>
                <div className="hero-content">
                    <h1 className="hero-title">Complete Payment</h1>
                    <p className="hero-subtitle">Secure Your Spot in the Class</p>
                </div>
            </section>

            <section className="section section-dark">
                <div style={{ maxWidth: '800px', margin: '0 auto' }}>

                    {/* Order Summary */}
                    <div className="card" style={{ marginBottom: '2rem' }}>
                        <h2 className="card-title" style={{ borderBottom: '1px solid rgba(255,255,255,0.1)', paddingBottom: '1rem', marginBottom: '1.5rem' }}>Order Summary</h2>
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '1rem', fontSize: '1.1rem' }}>
                            <span style={{ color: 'var(--color-gray-light)' }}>Student Name:</span>
                            <span style={{ fontWeight: 'bold' }}>{formData.name}</span>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '1rem', fontSize: '1.1rem' }}>
                            <span style={{ color: 'var(--color-gray-light)' }}>Selected Course:</span>
                            <span style={{ fontWeight: 'bold' }}>{formData.course || 'Silambam Course'}</span>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '1rem', fontSize: '1.1rem' }}>
                            <span style={{ color: 'var(--color-gray-light)' }}>Plan:</span>
                            <span style={{ fontWeight: 'bold' }}>Monthly Subscription</span>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '1.5rem', paddingTop: '1.5rem', borderTop: '1px dashed rgba(255,255,255,0.2)', fontSize: '1.4rem', color: 'var(--color-gold)' }}>
                            <span>Total Amount:</span>
                            <span>₹999</span>
                        </div>
                    </div>

                    {/* Payment Methods */}
                    <div className="card">
                        <h2 className="card-title" style={{ marginBottom: '1.5rem' }}>Select Payment Method</h2>

                        <div style={{ display: 'flex', gap: '1rem', marginBottom: '2rem' }}>
                            <button
                                onClick={() => setPaymentMethod('upi')}
                                style={{
                                    flex: 1,
                                    padding: '1rem',
                                    background: paymentMethod === 'upi' ? 'var(--color-gold)' : 'rgba(255,255,255,0.05)',
                                    color: paymentMethod === 'upi' ? 'var(--color-black)' : 'var(--color-white)',
                                    border: '1px solid var(--color-gold)',
                                    borderRadius: '8px',
                                    fontWeight: 'bold',
                                    cursor: 'pointer'
                                }}
                            >
                                UPI / QR Code
                            </button>
                            <button
                                onClick={() => setPaymentMethod('card')}
                                style={{
                                    flex: 1,
                                    padding: '1rem',
                                    background: paymentMethod === 'card' ? 'var(--color-gold)' : 'rgba(255,255,255,0.05)',
                                    color: paymentMethod === 'card' ? 'var(--color-black)' : 'var(--color-white)',
                                    border: '1px solid var(--color-gold)',
                                    borderRadius: '8px',
                                    fontWeight: 'bold',
                                    cursor: 'pointer'
                                }}
                            >
                                Credit / Debit Card
                            </button>
                        </div>

                        {paymentMethod === 'upi' ? (
                            <div style={{ textAlign: 'center', padding: '1rem' }}>
                                <div style={{
                                    width: '200px',
                                    height: '200px',
                                    background: 'white',
                                    margin: '0 auto 1.5rem',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    color: 'black',
                                    fontWeight: 'bold'
                                }}>
                                    [QR CODE PLACEHOLDER]
                                </div>
                                <p style={{ fontSize: '1.1rem', marginBottom: '0.5rem' }}>Scan to Pay with any UPI App</p>
                                <p style={{ color: 'var(--color-gold-light)' }}>UPI ID: deccanarts@upi</p>
                            </div>
                        ) : (
                            <div style={{ padding: '1rem' }}>
                                <div className="form-group">
                                    <label className="form-label">Card Number</label>
                                    <input type="text" className="form-input" placeholder="XXXX XXXX XXXX XXXX" />
                                </div>
                                <div style={{ display: 'flex', gap: '1rem' }}>
                                    <div className="form-group" style={{ flex: 1 }}>
                                        <label className="form-label">Expiry</label>
                                        <input type="text" className="form-input" placeholder="MM/YY" />
                                    </div>
                                    <div className="form-group" style={{ flex: 1 }}>
                                        <label className="form-label">CVV</label>
                                        <input type="password" className="form-input" placeholder="123" />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label className="form-label">Cardholder Name</label>
                                    <input type="text" className="form-input" placeholder="Name on Card" />
                                </div>
                            </div>
                        )}

                        <div style={{ marginTop: '2rem' }}>
                            <Button onClick={handlePayment} disabled={isProcessing} style={{ width: '100%', padding: '1.2rem', fontSize: '1.2rem', opacity: isProcessing ? 0.6 : 1, cursor: isProcessing ? 'not-allowed' : 'pointer' }}>
                                {isProcessing ? 'Processing...' : 'Pay ₹999 Securely'}
                            </Button>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Payment;
